import { ApiService } from '../../services/api.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';
import { Component, inject, Input, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  selectCategories,
  selectCategoriesLoading,
} from '../../store/selectors/categories.selectors';
import { loadCategories } from '../../store/actions/categories.actions';
import { CreateReport } from '../../models/create-report.model';
import { RealEstate } from '../../models/real-estate.model';
import { Car } from '../../models/car-model';
import { selectIsArabic } from '../../store/selectors/language.selectors';
import { addRealEstateReport } from '../../store/actions/real-estate.actions';
import { selectCarState } from '../../store/selectors/car.selectors';
import { selectRealEstateState } from '../../store/selectors/real-estate.selectors';
declare var bootstrap: any;

@Component({
  selector: 'app-report-ad',
  standalone: false,
  templateUrl: './report-ad.component.html',
  styleUrl: './report-ad.component.scss',
})
export class ReportAdComponent implements OnDestroy {
  @Input() userId = 0;
  @Input() profileImage?: string;
  private static nextId = 0;
  readonly modalId = 'reportAdModal-' + ++ReportAdComponent.nextId;
  private readonly api = inject(ApiService);
  private readonly toast = inject(ToastrService);
  private readonly translate = inject(TranslateService);
  get images(): string[] { return this.car?.pictures ?? this.realEstate?.pictures ?? (this.profileImage ? [this.profileImage] : []); }
  @Input() car: Car | undefined;
  @Input() realEstate: RealEstate | undefined;
  private readonly fb = inject(FormBuilder);
  private readonly store = inject(Store);

  categories$ = this.store.select(selectCategories);
  loadingCategories$ = this.store.select(selectCategoriesLoading);
  isArabic$: Observable<boolean> = this.store.select(selectIsArabic);

  isSubmitting = false;

  form = this.fb.group({
    reason: [undefined, Validators.required],
    comment: [undefined, Validators.maxLength(2000)],
    imageUrl: [''],
  });

  private destroy$ = new Subject<void>();

  constructor() {
    this.store.dispatch(loadCategories());
  }

  openModal(event?: MouseEvent) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const modalEl = document.getElementById(this.modalId);

    if (modalEl) {
      document.body.appendChild(modalEl);

      const modal = new bootstrap.Modal(modalEl);
      modal.show();
    }
  }

  submit() {
    if (this.form.invalid || this.isSubmitting) return;
    this.isSubmitting = true;
    const model = this.form.getRawValue() as unknown as CreateReport;
    const request = this.userId ? this.api.reportUser(this.userId, model)
      : this.api.createReport(this.car ? 'cars' : 'realEstate', this.car?.id ?? this.realEstate!.id, model);
    request.pipe(takeUntil(this.destroy$), finalize(() => this.isSubmitting = false)).subscribe({
      next: () => { this.toast.success(this.translate.instant('REPORT_ADD_SUCCESS')); this.form.reset(); this.close(); },
      error: () => this.toast.error(this.translate.instant('REPORT_ADD_FAIL')),
    });
  }

  close() {
    const modalEl = document.getElementById(this.modalId);
    const modal = bootstrap.Modal.getInstance(modalEl);
    modal?.hide();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get reason() {
    return this.form.get('reason');
  }
}
